import { IUser } from '../auth/types';

export enum LinkType {
    SHARE_CATEGORY = 'share_category',
    REFERRAL = 'referral',
    JOIN_ORGANIZATION = 'join_org',
    JOIN_ACCOUNT = 'join_account',
    MAGIC_AUTH = 'magic_auth',
}
export interface ILink {
    id: string;
    link_type: LinkType;
    user: IUser;
    metadata: any;
    slug?: string;
    created_at: string;
    valid_until: string;
}

export interface ILinkResponse {
    status: string;
    error?: string;
    data?: ILink;
}
